<template>
  <div class="d-teamcalendar__saved-views text-dark">
    <button class="bttn bttn-blue" v-if="itemsSelected.length > 0" @click="setIsSaveModal">{{
        i18n['save_view']
      }}
    </button>
    <DDropdown v-if="Object.keys(savedViews).length > 0" :isShowDots="false">
      <button slot="title" class="d-teamcalendar__saved-views__title bttn-simple">
        {{ i18n['saved_views'] }}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path fill-rule="evenodd"
                d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                clip-rule="evenodd"/>
        </svg>
      </button>
      <ul slot="list">
        <li class="d-teamcalendar__saved-views__view" v-for="(view, prop) in savedViews"
            @click="selectView(view, prop)">
          {{ prop }}
          <div class="icon__bg-circle icon__bg-circle--danger icon__bg-circle--small"
               @click.stop="setDeleteItemConfirm(prop)">
            <span class="icon-bin"></span>
          </div>
        </li>
      </ul>
    </DDropdown>
    <DModal v-if="isSaveModal" @close="closeIsSaveModal" :is-bg-overlay="true" :show-close="false">
      <div class="d-modal" slot="insertComponent">
        <div class="d-modal__header">
          <h2>{{ i18n['create_new_view'] }}</h2>
          <div class="d-modal__close icon__bg-circle" @click="closeIsSaveModal">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content">
          <div class="d-input-group">
            <label class="d-label">{{ i18n['give_the_view_a_title'] }}</label>
            <input v-model="title" :disabled="isInputTitleDisabled" @keyup.enter="saveView" ref="is_save_modal_input" class="d-input marg-1-top"
                   :placeholder="i18n['ex_title']">
          </div>
          <div class="d-input-group marg-2-top" v-if="Object.keys(savedViews).length > 0">
            <label class="d-label">{{ i18n['or_overwrite_existing'] }}</label>
            <select class="d-teamcalendar__saved-views__select" @change="setReplaceExisting($event.target.value)">
              <option value="" selected>{{ i18n['choose_existing'] }}</option>
              <option v-for="(view, prop) in savedViews">
                {{ prop }}
              </option>
            </select>
          </div>
        </div>
        <div class="d-modal__buttons pad-1">
          <button class="bttn bttn-simple marg-10-right" @click="closeIsSaveModal">{{
              $t('vue2.common.cancel')
            }}
          </button>
          <button v-if="title.length < 1" class="bttn submit-button submit-button--disabled">{{
              $t('vue2.common.create')
            }}
          </button>
          <button v-else class="bttn submit-button" @click="saveView">{{ $t('vue2.common.create') }}</button>
        </div>
      </div>
    </DModal>
    <ModalConfirmation
      v-if="isConfirmModal"
      :show-close="false"
      @close="isConfirmModal = false"
      @confirm="deleteItem">
    </ModalConfirmation>
  </div>
</template>

<script>
import DDropdown from '../common/DDropdown'
import ModalConfirmation from '../Modals/ModalConfirmation'
import DModal from '../common/DModal'

const I18N = {
  da: {
    save_view: 'Gem visning',
    saved_views: 'Mine visninger',
    create_new_view: 'Opret ny visning',
    give_the_view_a_title: 'Giv visningen en titel',
    ex_title: 'Eks. vikarer',
    or_overwrite_existing: 'Eller overskriv eksisterende',
    choose_existing: 'Vælg eksisterende..'
  },
  nb: {
    save_view: 'Lagre visning',
    saved_views: 'Lagrede visninger',
    create_new_view: 'Opprett ny visning',
    give_the_view_a_title: 'Gi visning en tittel',
    ex_title: 'Eks. vikarer',
    or_overwrite_existing: 'Eller overskriv eksisterende',
    choose_existing: 'Velg eksisterende..'
  },
  en: {
    save_view: 'Save view',
    saved_views: 'Saved views',
    create_new_view: 'Create new view',
    give_the_view_a_title: 'Give the view a title',
    ex_title: 'Ex. substitutes',
    or_overwrite_existing: 'Or overwrite existing',
    choose_existing: 'Choose existing..'
  }
}

export default {
  components: {DModal, ModalConfirmation, DDropdown},
  props: {
    itemsSelected: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      title: '',
      isConfirmModal: false,
      theDeleteItem: '',
      isSaveModal: false,
      isInputTitleDisabled: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    activeSchoolId () {
      return this.$store.state.activeSchool ? this.$store.state.activeSchool.id : null
    },
    storageName () {
      return 'school_' + this.activeSchoolId + '__team_calendar_views'
    },
    savedViews () {
      if (!this.userSettings || !this.userSettings[this.storageName]) {
        return {}
      }
      return JSON.parse(this.userSettings[this.storageName])
    }
  },
  methods: {
    setReplaceExisting (prop) {
      if (prop.length > 1) {
        this.title = prop
        this.isInputTitleDisabled = true
      } else {
        this.title = ''
        this.isInputTitleDisabled = false
      }
    },
    saveView () {
      if (!this.activeSchoolId || this.itemsSelected.length === 0 || this.title.length < 1) {
        return
      }
      let saveObj = JSON.parse(JSON.stringify(this.savedViews))
      if (Array.isArray(this.savedViews)) {
        saveObj = {}
      }
      saveObj[this.title] = this.itemsSelected.map(cal => cal.id)
      this.$store.dispatch('updateUserSettings', {[this.storageName]: JSON.stringify(saveObj)})
      this.closeIsSaveModal()
    },
    setDeleteItemConfirm (prop) {
      this.theDeleteItem = prop
      this.isConfirmModal = true
    },
    deleteItem () {
      let saveObj = JSON.parse(JSON.stringify(this.savedViews))
      delete saveObj[this.theDeleteItem]
      this.$store.dispatch('updateUserSettings', {[this.storageName]: JSON.stringify(saveObj)})
      this.closeIsSaveModal()
    },
    selectView (view, prop) {
      this.$emit('setSavedView', view)
    },
    reset () {
      this.theDeleteItem = ''
      this.isConfirmModal = false
      this.isInputTitleDisabled = false
      this.title = ''
    },
    closeIsSaveModal () {
      this.theDeleteItem = ''
      this.isConfirmModal = false
      this.isInputTitleDisabled = false
      this.title = ''
      this.isSaveModal = false
    },
    setIsSaveModal () {
      this.isSaveModal = true
      this.$nextTick(_ => {
        this.$refs.is_save_modal_input.focus()
      })
    }
  }
}
</script>

<style>
.d-teamcalendar__saved-views {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-teamcalendar__saved-views__view {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-teamcalendar__saved-views__view > div {
  margin-left: 2rem;
  opacity: 0;
}

.d-teamcalendar__saved-views__view:hover > div {
  opacity: 1;
}

.d-teamcalendar__saved-views__title {
  font-size: 12px;
  display: flex;
  font-weight: normal !important;
  align-items: center;
  background: #ffffff;
}

.d-teamcalendar__saved-views__title > svg {
  width: 1.2rem;
  margin-left: 0.5rem;
}

.d-teamcalendar__saved-views__select {
  margin-top: 1rem;
  border-radius: 4px;
  width: 100%;
}

select.d-teamcalendar__saved-views__select {
  color: #a2a3a6 !important;
}

input.d-input[disabled] {
  background: #eee;
  cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// TeamCalendarHeaderSaveView.vue?a4a0227c